import { getImpactCalculateTourForProject } from '@/domain/impact-calculate-tour/actions/get-impact-calculate-tour-for-project.action';
import { selectOrganisationInfos } from '@/domain/organisation/organisation.selectors';
import { selectCurrentProjectTour } from '@/domain/project-tour/project-tour.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourTravel } from '../entities/project-tour-ontour-travel.entity';
import { getTourTravels } from './get-tour-travels.action';

export type AddTourTravelParams = Params;

type Params = {
  sequenceId: number;
  tourTravel: Pick<
    TourTravel,
    | 'name'
    | 'connexionTypeWithEvent'
    | 'travelDistance'
    | 'fromEventId'
    | 'fromPosition'
    | 'toEventId'
    | 'toPosition'
  >;
};

type Result = TourTravel;

export const addTourTravel = createAppAsyncThunk(
  'projectTourOntour/addTourTravel',
  async (
    params: Params,

    {
      extra: { projectTourOntourGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<Result> => {
    try {
      const organisationId = selectOrganisationInfos(getState()).id;
      const createdTourTravel = await projectTourOntourGateway.addTravel(
        organisationId,
        params.sequenceId,
        params.tourTravel,
      );
      dispatch(getTourTravels({ sequenceId: params.sequenceId }));
      showSnackbarSuccess(snackbarGateway);
      const projectId = selectCurrentProjectTour(getState())?.id || -1;
      dispatch(getImpactCalculateTourForProject({ projectId }));
      return createdTourTravel;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('AddTourTravel.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('AddTourTravel.Message.error'));
}
